import { module as BaseModule } from 'modujs';
import Navigation from 'a11y-menu';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const navigation = new Navigation({
			menuId: 'nav-menu-mobile',
			click: true
		});

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => {
				try {
					navigation.init();
				} catch (e) {
					console.error('Error inicializando menumobile:', e);
				}
			});
		} else {
			try {
				navigation.init();
			} catch (e) {
				console.error('Error inicializando menumobile:', e);
			}
		}
	}
}
